import { Flex } from "antd";
import dayjs from "dayjs";
import { ReactNode, useContext } from "react";

import { ENVIRONMENT } from "@/config";
import { SWContext } from "@/context/SWContext";
import { MainContainer } from "@/shared/layout/Layout";
import { AppIdentity } from "@/shared/ui/AppIdentity";
import BaseButton from "@/shared/ui/BaseButton";
import { PrimaryText, SecondaryText } from "@/shared/ui/Typography";
import { Maintenance } from "@/types";

import { StyledSettingOutlined } from "./Styles";

const checkMaintenance = (maintenance?: Maintenance | null) => {
    if (!maintenance?.enabled) return false;

    const now = dayjs().valueOf();
    const startsAt = maintenance.startsAt
        ? dayjs(maintenance.startsAt).valueOf()
        : null;
    const endsAt = maintenance.endsAt
        ? dayjs(maintenance.endsAt).valueOf()
        : null;

    if (startsAt && now < startsAt) return false;
    if (endsAt && now > endsAt) return false;

    return true;
};

export const MaintenanceBlocker = ({ children }: { children: ReactNode }) => {
    const { maintenance } = useContext(SWContext);

    const isMaintenanceActive = checkMaintenance(maintenance);

    if (isMaintenanceActive && ENVIRONMENT !== "dev-local") {
        return (
            <MainContainer>
                <Flex
                    vertical
                    gap={32}
                    flex={1}
                    align="center"
                    justify="center"
                >
                    <AppIdentity logoHeight={180} />

                    <Flex vertical gap={16} align="center">
                        <Flex gap={8} align="center">
                            <StyledSettingOutlined />

                            <PrimaryText
                                fontSize={20}
                                fontWeight="600"
                                textAlign="center"
                            >
                                Технічні роботи
                            </PrimaryText>
                        </Flex>

                        <PrimaryText fontSize={15} textAlign="center">
                            {maintenance?.message ||
                                "Застосунок тимчасово недоступний через технічні роботи."}
                        </PrimaryText>

                        {maintenance?.endsAt && (
                            <SecondaryText textAlign="center">
                                Орієнтовно до:{" "}
                                {dayjs(maintenance?.endsAt).format("HH:mm")}
                            </SecondaryText>
                        )}
                    </Flex>

                    <BaseButton
                        type="primary"
                        onClick={() => window.location.reload()}
                    >
                        Оновити сторінку
                    </BaseButton>
                </Flex>
            </MainContainer>
        );
    }

    return <>{children}</>;
};
